<template>
  <div>
    <div
      style="
        width: 100%;
        display: flex;
        justify-content: end;
        margin-bottom: 12px;
      "
    >
      <div class="mr-5">
        <el-select
          size="mini"
          placeholder="Cliente"
          v-model="CustomersFilter"
          filterable
          clearable
          @change="handleFilters"
        >
          <el-option
            v-for="(item, index) in list_customersSelect"
            :key="index"
            :value="item.ClientCode"
            :label="item.Name"
          />
        </el-select>
      </div>
    </div>

    <rabbey-table-3
      :paginationApi="{
        currentPage: page,
        pageSize: limit,
        total: totalItems
      }"
      :pageSizes="pageSizes"
      :loading="loading"
      :paginateFromApi="true"
      :data="items"
      :columns="columnsDetails"
      @update-current-page="handleCurrentPage"
      @update-page-size="handlePageSize"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";

export default {
  data() {
    return {
      page: 1,
      limit: 10,
      totalItems: 0,
      pageSizes: [10, 30, 50, 100, 600],
      dialogVisible: false,
      drawer: false,
      loading: false,
      items: [],
      CustomersFilter: "",
      columnsDetails: [
        {
          prop: "CustomerCode",
          label: "Codigo",
          width: 100,
          sortable: true
        },
        {
          prop: "CustomerName",
          label: "Nombre",
          width: 520,
          sortable: true
        },
        {
          prop: "InvoiceDate",
          label: "Fecha de factura",
          width: 180,
          sortable: true,
          formatter: DatetimeFormatter
        },
        {
          prop: "SendDate",
          label: "Fecha de envio",
          width: 180,
          sortable: true,
          formatter: DatetimeFormatter
        },
        {
          prop: "SendgridMessage",
          label: "Mensage",
          width: 360,
          sortable: true
        },
        {
          prop: "CreateBy",
          label: "Enviado por",
          width: 180,
          sortable: true
        }
      ]
    };
  },
  created() {
    this.getNotificationNavixy();
    this.fetchCustomers();
  },
  methods: {
    ...mapActions({
      fetchCustomers: "customers/getCustomers"
    }),
    handleFilters() {
      this.getNotificationNavixy();
    },
    handleCurrentPage(page) {
      this.page = page;

      this.getNotificationNavixy();
    },
    handlePageSize(limit) {
      this.limit = limit;

      this.getNotificationNavixy();
    },
    getNotificationNavixy() {
      this.items = [];
      this.loading = true;
      this.$http
        .get(`/api/invoices/GetNotificationNavixy`, {
          timeout: 3 * 60 * 1000,
          params: {
            Page: this.page,
            Limit: this.limit,
            CustomerCode: this.CustomersFilter
          }
        })
        .then((resp) => {
          const { Items, ItemCount, CurrentPage } = resp.data;

          this.items = Items;
          this.totalItems = ItemCount;
          this.page = CurrentPage;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    ...mapGetters({
      list_customersSelect: "customers/list_to_select",
      loading_customers: "customers/isLoading"
    })
  }
};
</script>
